<tilby-dialog-toolbar
    [title]="'STOCK.EXPORT_DIALOG.SEND_EMAIL' | translate"
    [hideConfirm]="form.invalid"
    (confirm)="confirm()"
/>
<tilby-dialog-content class="tw-w-full">
    <form class="tw-flex tw-flex-col tw-gap-2 tw-pt-2" [formGroup]="form" (ngSubmit)="confirm()">
        <mat-form-field appearance="outline" class="tw-w-full">
            <mat-label>{{ 'STOCK.EXPORT_DIALOG.EMAIL' | translate }}</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email">

            @if (form.controls.email.hasError('required')) {
                <mat-error>{{ 'NG_MESSAGES.REQUIRED_FIELD' | translate }}</mat-error>
            } @else if (form.controls.email.invalid) {
                <mat-error>{{ 'NG_MESSAGES.INVALID_VALUE' | translate }}</mat-error>
            }
        </mat-form-field>

        @if (data.allowDate) {
            <mat-form-field appearance="outline" class="tw-w-full">
                <mat-label>{{ 'STOCK.EXPORT_DIALOG.EXPORT_AT_DATE' | translate }}</mat-label>
                <input matInput formControlName="date" [matDatepicker]="picker" [max]="today">
                <mat-datepicker-toggle matIconSuffix [for]="picker" />
                <mat-datepicker #picker />

                @if (form.controls.date.invalid) {
                    <mat-error>{{ 'NG_MESSAGES.INVALID_VALUE' | translate }}</mat-error>
                }
            </mat-form-field>
        }
    </form>
</tilby-dialog-content>
